import React from "react"
import types from "prop-types"
import { ACTIVITY_HUB_FORM_SUBMISSION_REPORTS_PATH } from "utils/routeHelpers"
import { PrimaryButton } from "shared/buttons"

const NewTaskReportExportFormActions = ({ disabled = false, exportTaskReport }) => (
  <div className="flex justify-center gap-4">
    <a className="button secondary-button" href={ACTIVITY_HUB_FORM_SUBMISSION_REPORTS_PATH}>
      Cancel
    </a>
    <PrimaryButton disabled={disabled} text="Export" onClick={exportTaskReport} />
  </div>
)

NewTaskReportExportFormActions.propTypes = {
  disabled: types.bool,
  exportTaskReport: types.func.isRequired,
}

export default NewTaskReportExportFormActions
